// Settings search: a normalised substring match, plus per-tab tallies so
// people can see which tab holds the matches.
export const normalise = (value) =>
  (value ?? '').toString().toLowerCase().replace(/\s+/g, ' ').trim()

export const matchesQuery = (text, query) => {
  const needle = normalise(query)
  if (!needle) return true
  return normalise(text).includes(needle)
}

// entries: [{ tab, text }]
export const countsByTab = (entries, query) => {
  const needle = normalise(query)
  if (!needle) return {}
  const counts = {}
  entries.forEach(({ tab, text }) => {
    if (!matchesQuery(text, needle)) return
    const key = tab || ''
    counts[key] = (counts[key] || 0) + 1
  })
  return counts
}

export const totalMatches = (counts) =>
  Object.values(counts).reduce((sum, n) => sum + n, 0)
